import { ModalProps } from '@/components/molecules/Modal/Modal'
import { create } from 'zustand'

type GlobalModalState = ModalProps & {
    setModalState: (props: Partial<ModalProps>) => void
    resetModalState: () => void
}

const emptyState: ModalProps = {
    isOpen: false,
    title: '',
    description: '',
    icon: '',
    content: null,
    onClose: () => undefined,
}

export const useGlobalModalStore = create<GlobalModalState>((set) => ({
    ...emptyState,
    setModalState: (props) => {
        set(() => ({ ...emptyState, ...props }))
    },
    resetModalState: () => {
        set((state) => ({ ...state }))
    },
    onClose: () => {
        set(emptyState)
    },
}))
